import { Component, createElement, lazy, Suspense, type ComponentType, type FunctionComponent, type PropsWithChildren } from 'react';
import { Button } from 'antd';
import { Carregando } from '@/components/comum/Carregando';

class RecuperarPagina extends Component<PropsWithChildren, { falhou: boolean }> {
  state = { falhou: false };
  static getDerivedStateFromError() { return { falhou: true }; }
  render() {
    if (!this.state.falhou) return this.props.children;
    return createElement('section', { role: 'alert', style: { padding: 24 } },
      createElement('h1', null, 'Não foi possível abrir esta página'),
      createElement('p', null, 'Tente carregar a página novamente.'),
      createElement(Button, { type: 'primary', onClick: () => window.location.reload() }, 'Recarregar página'),
    );
  }
}
/** Importa apenas quando a rota é renderizada, mantendo as guardas de acesso existentes. */
export function paginaSobDemanda<P extends object>(carregar: () => Promise<{ default: FunctionComponent<P> }>): FunctionComponent<P> {
  const Pagina = lazy(carregar);
  const Conteudo = Pagina as ComponentType<P>;
  return function PaginaCarregada(props: P) {
    return createElement(RecuperarPagina, null,
      createElement(Suspense, { fallback: createElement(Carregando, { variante: 'pagina', texto: 'Abrindo página...' }) },
        createElement(Conteudo, props),
      ),
    );
  };
}
